/* @flow */
import * as React from 'react';

import AdminOrgAdminsView from 'admin/components/AdminOrgAdminsView';
import AdminDistrictSchoolAdminsView from 'admin/components/AdminDistrictSchoolAdminsView';

type Props = {
  orgId?: ?number,
  orgType: string,
};

export default class AdminSchoolAdminsView extends React.Component<Props> {
  render() {
    const { orgId, orgType } = this.props;

    if (orgType === 'District') {
      return <AdminDistrictSchoolAdminsView orgId={orgId} />;
    } else {
      return <AdminOrgAdminsView orgId={orgId} />;
    }
  }
}
